<template>
  <div>
    <div class="cms-text-excerpt" v-html="excerpt"></div>
    <br />
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from "vue";
import { CmsDocument, CmsTextExcerpt } from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";

const props = defineProps<{
  slice: CmsTextExcerpt | null;
}>();

const doc = ref<CmsDocument | null>(null);

const loadDocument = async () => {
  if (props.slice) {
    const documentData = await cms.getById(
      props.slice.primary.document.type,
      props.slice.primary.document.id,
    );
    doc.value = documentData;
  }
};

const excerpt = computed(() => {
  if (doc.value && props.slice) {
    if (!props.slice.primary.field_name) {
      return `<p style='color:red'>MISSING FIELD NAME ${doc.value.id} -> ${props.slice.primary.document.id}</p>`;
    }
    const field_name = props.slice.primary.field_name.split(".").slice(-1)[0];
    const docExcerpt = doc.value.data[field_name];

    if (docExcerpt) {
      return cms.asHtml(docExcerpt);
    }
    return `<p style='color:red'>MISSING EXCERPT ${doc.value.id} -> ${props.slice.primary.document.id}</p>`;
  }
  return "";
});

onMounted(() => {
  loadDocument();
});
</script>

<style lang="less"></style>
